import Ivora91 from '../Ivora Grande 9/Ivora 9 (1).webp'
import Ivora92 from '../Ivora Grande 9/Ivora 9 (2).webp'
import Ivora93 from '../Ivora Grande 9/Ivora 9 (3).webp'
import Ivora94 from '../Ivora Grande 9/Ivora 9 (4).webp'
import Ivora95 from '../Ivora Grande 9/Ivora 9 (5).webp'
import Ivora96 from '../Ivora Grande 9/Ivora 9 (6).webp'
import Ivora97 from '../Ivora Grande 9/Ivora 9 (7).webp'
import Ivora98 from '../Ivora Grande 9/Ivora 9 (8).webp'
import Ivora99 from '../Ivora Grande 9/Ivora 9 (9).webp'
import Ivora910 from '../Ivora Grande 9/Ivora 9 (10).webp'
import Ivora911 from '../Ivora Grande 9/Ivora 9 (11).webp'


const Ivora9images =[
Ivora91,Ivora92,Ivora93,Ivora94,Ivora95,Ivora96,Ivora97,Ivora98,Ivora99,Ivora910,Ivora911
]

export default Ivora9images;